module.exports = __webpack_public_path__ + "public/adminIcons/becomeHost.svg?94e10290";